export const BodySpacer = () => (
    <div style={{height: 128}}/>
)